import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import TableContext from '../TableContext';
import { sort } from '../sorting';
import { getLanguage } from '../../../features/app/selectors';

const SortEvaluator = ({ data, children }) => {
  const { sorting, columns } = useContext(TableContext);
  const language = useSelector(getLanguage);

  const sortedData = useMemo(() => {
    return sort(data, sorting, columns, language);
  }, [data, sorting, columns, language]);

  return children(sortedData);
};

export default SortEvaluator;
